module.exports = __webpack_public_path__ + "img/UTKODA-8.19e347e6.jpg";